import { useEffect, useState } from 'react'
import { Body } from '../../../Layouts/Body'
import { OutlineMetaButton } from '../../../../components/Buttons/OutlineMetaButton'
import { WhiteBox } from '../../../../components/WhiteBox'
import { iItemIntegracao } from '../../../../interfaces'
import { CheckTitulo, FlexItems, Titulo, ColumnItem } from './styles'
import { FormControl, FormLabel, Input } from '@chakra-ui/react'

interface iChecklistprops {
  itemIntegracao: iItemIntegracao
  isVisible: boolean
  UpdateResposta: (resposta: iChekIntegracao[], itemId: string) => void
}

interface iChekIntegracao {
  texto: string
  check: boolean
  observacaoIson: boolean
  observacao?: string
}

export const ColaboradorChecklist: React.FC<iChecklistprops> = ({ itemIntegracao, isVisible, UpdateResposta }) => {
  if (!isVisible) {
    return null
  }
  const [ItensCheck, setItensCheck] = useState<iChekIntegracao[]>([])
  const [NoChangeItensCheck, setNoChangeItensCheck] = useState<iChekIntegracao[]>([])

  useEffect(() => {
    if (itemIntegracao.checklist !== undefined) {
      for (let i = 0; i < itemIntegracao.checklist.length; i++) {
        setItensCheck(oldArray => [...oldArray,
          {
            check: itemIntegracao.checklist !== undefined ? itemIntegracao.checklist[i]?.check : false,
            observacaoIson: false,
            texto: itemIntegracao.checklist !== undefined ? itemIntegracao.checklist[i]?.texto : ''
          }])
        setNoChangeItensCheck(oldArray => [...oldArray,
          {
            check: itemIntegracao.checklist !== undefined ? itemIntegracao.checklist[i]?.check : false,
            observacaoIson: false,
            texto: itemIntegracao.checklist !== undefined ? itemIntegracao.checklist[i]?.texto : ''
          }])
      }
    }
  }, [])

  useEffect(() => {
    UpdateResposta(ItensCheck, itemIntegracao.id)
  }, [ItensCheck])

  function UpdateItemArray(index: number, check: boolean, ObsIsOn: boolean, Observacao?: string): void {
    const array = [...ItensCheck]
    array[index].check = check
    array[index].observacao = Observacao
    array[index].observacaoIson = ObsIsOn
    setItensCheck(array)
  }

  return (
    <Body>
      <h2 style={{ marginBottom: '1rem', color: 'var(--a3)', marginTop: '2rem' }}>Integração</h2>
      <WhiteBox>
        <Titulo>{itemIntegracao.descricao}</Titulo>
        {
          ItensCheck.map((r: iChekIntegracao, i) => {
            return (
              <ColumnItem key={i}>
                <FlexItems>
                  <input checked={r.check} disabled={NoChangeItensCheck[i].check} onChange={(e) => UpdateItemArray(i, e.target.checked, r.observacaoIson)} type={'checkbox'} />
                  <CheckTitulo style={{ opacity: NoChangeItensCheck[i].check ? '0.5' : '' }}>{r.texto}</CheckTitulo>
                  {
                    r.observacaoIson
                      ? <OutlineMetaButton
                        size='sm'
                        color='terc1'
                        onClick={() => UpdateItemArray(i, r.check, false)}
                      >Cancelar</OutlineMetaButton>
                      : <OutlineMetaButton
                        size='sm'
                        color='terc1'
                        styles={{ display: NoChangeItensCheck[i].check ? 'none' : '' }}
                        onClick={() => NoChangeItensCheck[i].check ? '' : UpdateItemArray(i, r.check, true)}
                      >Observação</OutlineMetaButton>
                  }
                </FlexItems>
                {
                  (r.observacaoIson) && (
                    <FormControl>
                      <FormLabel color={'var(--terc1)'}>Observação</FormLabel>
                      <Input onChange={(e) => UpdateItemArray(i, r.check, true, e.target.value)}placeholder='Digite sua observação' type={'text'} borderColor='var(--Gray4)' />
                    </FormControl>
                  )
                }
              </ColumnItem>
            )
          })
        }
      </WhiteBox>
    </Body>
  )
}
